import React from 'react';

const Footer = () => {
  const today = new Date();
  const formattedDate = today.toLocaleDateString('pt-BR', { day: '2-digit', month: '2-digit', year: 'numeric' });
  return (
    <footer className="bg-white dark:bg-gray-800 border-t border-gray-200 dark:border-gray-700">
      <div className="max-w-7xl mx-auto px-6 py-3 flex items-center justify-between text-sm text-gray-600 dark:text-gray-300">
        <span>Versão v1000.5.101</span>
        <span>Data: {formattedDate}</span>
        <span>Direitos Autorais © @ACE CDL Itaúna</span>
      </div>
    </footer>
  );
};

export default Footer;
